import type { ComponentProps } from "react";

import {
  BestWindowVerdict as SharedBestWindowVerdict,
  ShubhMuhuratDigest as SharedShubhMuhuratDigest,
  todayISTDateString as sharedTodayISTDateString,
} from "@/components/muhurat/ShubhMuhuratDigest";

/** Route-local compatibility boundary; shared components own the render implementation. */
export function BestWindowVerdict(props: ComponentProps<typeof SharedBestWindowVerdict>) {
  return <SharedBestWindowVerdict {...props} />;
}

export function ShubhMuhuratDigest(props: ComponentProps<typeof SharedShubhMuhuratDigest>) {
  return <SharedShubhMuhuratDigest {...props} />;
}

export function todayISTDateString(): string {
  return sharedTodayISTDateString();
}
